import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';

function JobPage() {
  const [toast, setToast] = useState(null);
  const [sending, setSending] = useState(false);
  const [cvName, setCvName] = useState(null);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const showToast = (msg, type = 'success') => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 4000);
  };

  return (
    <div className="v">
      {toast && (
        <div className={`v-toast v-toast-${toast.type}`}>
          <span>{toast.type === 'success' ? '✓' : '✕'}</span> {toast.msg}
        </div>
      )}

      {/* ─── NAV simplifié ─── */}
      <nav className="v-nav">
        <div className="v-nav-inner">
          <Link to="/" className="v-nav-logo">Shynea</Link>
          <Link to="/#carrieres" className="v-btn v-btn-outline" style={{ fontSize: 13 }}>
            &larr; Retour aux offres
          </Link>
        </div>
      </nav>

      {/* ─── HEADER OFFRE ─── */}
      <section className="v-section" style={{ paddingBottom: 0 }}>
        <div className="v-container" style={{ maxWidth: 900 }}>
          <Link to="/#carrieres" style={{ fontSize: 13, color: 'var(--text-muted)', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 6, marginBottom: 24 }}>
            ← Toutes les offres
          </Link>

          <div className="v-job-page-header">
            <span className="v-badge-open-sm" style={{ marginBottom: 12, display: 'inline-block' }}>CDD — 6 mois</span>
            <h1 className="serif" style={{ fontSize: 42, fontWeight: 600, lineHeight: 1.1, marginBottom: 20 }}>
              Technico-Commercial Terrain Junior F/H
            </h1>
            <div className="v-job-meta-tags">
              <span className="v-job-tag">📍 Dakar</span>
              <span className="v-job-tag">🗓️ Juin 2026</span>
              <span className="v-job-tag">🏠 2j télétravail / 3j terrain</span>
            </div>
          </div>
        </div>
      </section>

      {/* ─── CONTENU OFFRE ─── */}
      <section className="v-section">
        <div className="v-container" style={{ maxWidth: 900 }}>
          <div className="v-job-page-body">
            <div className="v-job-page-main">
              <div className="v-job-block">
                <h3>L&apos;entreprise</h3>
                <p>
                  Entreprise innovante, SHYNEA est une application pionnière dédiée à la gestion
                  des salons de coiffure en Afrique. De la prise de rendez-vous au paiement sécurisé,
                  notre solution simplifie et optimise toute l&apos;activité du salon.
                </p>
              </div>

              <div className="v-job-block">
                <h3>Vos missions principales</h3>
                <ul>
                  <li>Prospecter des salons de beauté sur le terrain</li>
                  <li>Présenter l&apos;application et faire des démonstrations</li>
                  <li>Convaincre et signer de nouveaux partenaires</li>
                  <li>Accompagner les clients dans leur prise en main</li>
                  <li>Suivre et remonter les retours terrain à l&apos;équipe produit</li>
                </ul>
              </div>

              <div className="v-job-block">
                <h3>Profil recherché</h3>
                <ul>
                  <li>Bac à Bac +3</li>
                  <li>Fibre commerciale et goût du challenge</li>
                  <li>Dynamique, adaptable et motivé(e)</li>
                  <li>Nous recherchons avant tout des talents avec l&apos;envie d&apos;apprendre et de se dépasser</li>
                </ul>
              </div>
            </div>

            <div className="v-job-page-side">
              <div className="v-job-block v-job-block-highlight">
                <h4>Pourquoi nous rejoindre ?</h4>
                <div className="v-job-perks">
                  <div className="v-job-perk"><span>🎓</span><p>Formation et accompagnement</p></div>
                  <div className="v-job-perk"><span>💰</span><p>Rémunération évolutive</p></div>
                  <div className="v-job-perk"><span>🚀</span><p>Environnement dynamique</p></div>
                  <div className="v-job-perk"><span>📱</span><p>Avantages (téléphone, primes…)</p></div>
                </div>
              </div>

              <div className="v-job-block" style={{ marginTop: 24 }}>
                <h4>Processus de recrutement</h4>
                <div className="v-job-steps">
                  <div className="v-job-step"><span className="v-job-step-num">1</span><p>Échange téléphonique</p></div>
                  <div className="v-job-step"><span className="v-job-step-num">2</span><p>Entretien</p></div>
                  <div className="v-job-step"><span className="v-job-step-num">3</span><p>Rencontre avec les managers</p></div>
                </div>
              </div>

              <a href="#postuler" className="v-btn v-btn-orange" style={{ width: '100%', justifyContent: 'center', marginTop: 24 }}>
                Postuler maintenant →
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ─── FORMULAIRE CANDIDATURE ─── */}
      <section id="postuler" className="v-section-alt">
        <div className="v-container" style={{ maxWidth: 680 }}>
          <div className="v-center" style={{ marginBottom: 32 }}>
            <h2 className="v-h2 serif">Postuler</h2>
            <p style={{ fontSize: 14, color: 'var(--text-secondary)' }}>
              Envoyez votre candidature directement depuis cette page.
            </p>
          </div>
          <form
            className="v-form"
            onSubmit={async (e) => {
              e.preventDefault();
              if (sending) return;
              setSending(true);
              const fd = new FormData(e.target);
              try {
                const res = await fetch('/api/candidature', {
                  method: 'POST',
                  body: fd,
                });
                if (res.ok) {
                  showToast('Candidature envoyée avec succès !');
                  e.target.reset();
                  setCvName(null);
                } else {
                  showToast('Erreur lors de l\'envoi.', 'error');
                }
              } catch {
                showToast('Erreur réseau, réessayez.', 'error');
              }
              setSending(false);
            }}
          >
            <div className="v-form-row">
              <div className="v-form-group">
                <label htmlFor="a-name">Nom complet *</label>
                <input id="a-name" name="name" type="text" placeholder="Votre nom" required />
              </div>
              <div className="v-form-group">
                <label htmlFor="a-email">Email *</label>
                <input id="a-email" name="email" type="email" placeholder="votre@email.com" required />
              </div>
            </div>
            <div className="v-form-row">
              <div className="v-form-group">
                <label htmlFor="a-phone">Téléphone</label>
                <input id="a-phone" name="phone" type="tel" placeholder="+221 7X XXX XX XX" />
              </div>
              <div className="v-form-group">
                <label htmlFor="a-poste">Poste visé *</label>
                <select id="a-poste" name="poste" defaultValue="Technico-Commercial Terrain Junior" required>
                  <option>Technico-Commercial Terrain Junior</option>
                  <option>Candidature spontanée</option>
                </select>
              </div>
            </div>
            <label htmlFor="a-cv">CV (PDF, DOC — max 5 Mo)</label>
            <div className="v-file-upload">
              <input
                id="a-cv"
                name="cv"
                type="file"
                accept=".pdf,.doc,.docx"
                className="v-file-input"
                onChange={(e) => setCvName(e.target.files[0]?.name || null)}
              />
              <label htmlFor="a-cv" className="v-file-label">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9 2v10M9 2L5 6M9 2l4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M2 12v2a2 2 0 002 2h10a2 2 0 002-2v-2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
                {cvName ? cvName : 'Joindre votre CV'}
              </label>
              {cvName && (
                <button type="button" className="v-file-remove" onClick={() => {
                  document.getElementById('a-cv').value = '';
                  setCvName(null);
                }}>✕</button>
              )}
            </div>
            <label htmlFor="a-motiv">Motivation *</label>
            <textarea id="a-motiv" name="motivation" placeholder="Parlez-nous de vous et de votre intérêt pour ce poste..." required />
            <button type="submit" className="v-btn v-btn-orange" style={{ width: '100%', justifyContent: 'center', marginTop: 4 }} disabled={sending}>
              {sending ? 'Envoi en cours...' : 'Envoyer ma candidature →'}
            </button>
          </form>
        </div>
      </section>

      {/* ─── FOOTER LIGHT ─── */}
      <footer className="v-footer">
        <div className="v-container">
          <div className="v-footer-bottom" style={{ borderTop: 'none', paddingTop: 0 }}>
            <div className="v-footer-bottom-left">
              <Link to="/" style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontWeight: 600, color: '#fff', textDecoration: 'none' }}>Shynea</Link>
              <span>© {new Date().getFullYear()} Shynea · Tous droits réservés</span>
            </div>
            <div className="v-footer-bottom-right">
              <span>Fait avec soin à Dakar</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default JobPage;
